import React, {useState, useRef, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {
    FaArrowLeft,
    FaWallet,
    FaCreditCard,
    FaDollarSign,
    FaPlusCircle,
} from "react-icons/fa";
import ProfileService from "../../../../services/Profile";
import {useDispatch} from "react-redux";
import {showToast} from "../../../../redux/slices/toastSlice";
import TransactionService from "../../../../services/Transaction";

export default function Wallet() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedGateway, setSelectedGateway] = useState("");
    const [selectedAmount, setSelectedAmount] = useState(0);
    const [chargeCode, setChargeCode] = useState("");
    const [showCodePopup, setShowCodePopup] = useState(false);
    const codePopupContentRef = useRef(null);
    const [ports, setPorts] = useState([{port_name: "PayPal"}]);
    const [transactionToken, setTransactionToken] = useState("");

    const AMOUNT_PRESETS = [50000, 100000, 200000, 500000, 1000000, 2000000];
    const TRANSACTION_FEE_PERCENT = 0.02;
    const [currentBalance, setCurrentBalance] = useState(0);

    async function getProfile() {
        try {
            const res = await ProfileService.getProfile();
            setCurrentBalance(res.data?.data?.finduser?.wallet.balance || 0);
        } catch (err) {
            console.log("Error fetching profile:", err);
        }
    }

    useEffect(() => {
        getProfile();
    }, []);

    // async function getTransactionPorts() {
    //     try {
    //         const res = await ProfileService.getTransactionList();
    //         if (res.status === 200) {
    //             setPorts(res?.data?.data);
    //         }
    //         console.log("Transaction Ports:", res?.data?.data);
    //     } catch (err) {
    //     }
    // }

    // useEffect(() => {
    //     getTransactionPorts();
    // }, []);

    const handleGatewayChange = (value) => {
        setSelectedGateway(value);
    };
    console.log(selectedGateway);

    const handlePresetAmount = (amount) => {
        setSelectedAmount(amount);
    };

    const handleAmountChange = (e) => {
        let value = e.target.value;
        value = value.replace(/[^\d]/g, "");

        setSelectedAmount(value ? Number(value) : 0);
    };

    const fee = Math.round(selectedAmount * TRANSACTION_FEE_PERCENT);
    const total = selectedAmount + fee;

    const handleChargeClick = async () => {
        if (selectedGateway === "code") {
            setShowCodePopup(true);
        } else {
            if (selectedAmount > 0) {
                dispatch(
                    showToast({
                        type: "success",
                        message: "Redirecting to payment gateway",
                    })
                );
                try {
                    const body = {
                        price: selectedAmount,
                        transaction_port: selectedGateway,
                    };
                    console.log(body);
                    const res = await TransactionService.createTransaction(body);
                    setTransactionToken(res?.data?.message?.token);
                    console.log(res);
                } catch (err) {
                    console.log(err);
                }
            } else {
                dispatch(
                    showToast({type: "error", message: "Please enter an amount"})
                );
            }
        }
    };

    console.log("Transaction Token:", transactionToken);

    useEffect(() => {
        if (showCodePopup && codePopupContentRef.current) {
            setTimeout(() => {
                codePopupContentRef.current?.classList.remove("translate-y-full");
            }, 10);
        }
    }, [showCodePopup]);

    // const handleCreditCodeChange = (value) => {
    //     setChargeCode(value);
    // };

    const handleCodeSubmit = async () => {
        if (chargeCode.trim() === "") {
            dispatch(
                showToast({type: "error", message: "Please enter a charge code"})
            );
            return;
        }
        try {
            const body = {
                code: chargeCode,
            };
            const res = await TransactionService.creditCodeChargeWallet(body);
            getProfile();
            console.log(res);
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div>
            <div className="bg-gray-50 min-h-screen pb-6">
                <header className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4">
                    <div className="flex items-center justify-between">
                        <button
                            onClick={() => navigate("/profile")}
                            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-all"
                        >
                            <FaArrowLeft className="text-gray-600"/>
                        </button>
                        <h1 className="text-xl font-bold text-gray-900">Charge Wallet</h1>
                        <div className="w-10"></div>
                    </div>
                </header>

                <section className="px-4 py-6 mt-16">
                    <div className="bg-gradient-to-br from-blue-600 to-indigo-500 rounded-3xl p-3 shadow-lg">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-4">
                                <div
                                    className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center ml-3">
                                    <FaWallet className="text-white text-xl"/>
                                </div>
                                <div>
                                    <p className="text-white/80 text-sm mb-1">Current Balance</p>
                                    <h2 className="text-white text-3xl font-bold">
                                        {currentBalance.toLocaleString("en-US")} $
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="px-4 mb-6">
                    <div className="bg-white rounded-3xl p-5 shadow-sm border border-gray-100">
                        <div className="flex items-center mb-4 gap-4">
                            <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center ml-3">
                                <FaCreditCard className="text-blue-600"/>
                            </div>
                            <h3 className="font-semibold text-gray-900 text-base">
                                Payment Gateway
                            </h3>
                        </div>

                        <div className="space-y-3">
                            {ports.map((port) => (
                                // <label  className={`flex items-center justify-between p-4 bg-gray-50 rounded-2xl cursor-pointer hover:bg-gray-100 transition-colors border-2 ${selectedGateway === port.identifier ? 'border-blue-600' : 'border-transparent'}`}>
                                //     <div className="flex items-center">
                                <label
                                    key={port.id}
                                    className={`flex items-center justify-between p-4 bg-gray-50 rounded-2xl cursor-pointer hover:bg-gray-100 transition-colors border-2 ${
                                        selectedGateway === port?.port_name
                                            ? "border-blue-600"
                                            : "border-transparent"
                                    }`}
                                >
                                    <div className="flex items-center gap-4">
                                        <div
                                            className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
                                            <FaCreditCard className="text-green-600"/>
                                        </div>
                                        <span className="text-gray-900 font-medium">
                                          {port?.port_name}
                                        </span>
                                    </div>
                                    <input
                                        type="radio"
                                        name="gateway"
                                        value={port?.port_name}
                                        checked={selectedGateway === port?.port_name}
                                        onChange={() => handleGatewayChange(port?.port_name)}
                                        className="w-5 h-5 text-blue-600"
                                    />
                                </label>
                            ))}
                            {/*<label*/}
                            {/*    className={`flex items-center justify-between p-4 bg-gray-50 rounded-2xl cursor-pointer hover:bg-gray-100 transition-colors border-2 ${*/}
                            {/*        selectedGateway === "code"*/}
                            {/*            ? "border-blue-600"*/}
                            {/*            : "border-transparent"*/}
                            {/*    }`}*/}
                            {/*>*/}
                            {/*    <div className="flex items-center">*/}
                            {/*        <div*/}
                            {/*            className="w-10 h-10 bg-purple-100 rounded-xl flex items-center justify-center ml-3">*/}
                            {/*            <FaTicket className="text-purple-600"/>*/}
                            {/*        </div>*/}
                            {/*        <span className="text-gray-900 font-medium">Charge Code</span>*/}
                            {/*    </div>*/}
                            {/*    <input*/}
                            {/*        type="radio"*/}
                            {/*        name="gateway"*/}
                            {/*        value="code"*/}
                            {/*        checked={selectedGateway === "code"}*/}
                            {/*        onChange={(e) => handleGatewayChange(e.target.value)}*/}
                            {/*        className="w-5 h-5 text-blue-600"*/}
                            {/*    />*/}
                            {/*</label>*/}
                        </div>
                    </div>
                </section>

                {/*{selectedGateway === "code" ? (*/}
                {/*    <section className="px-4 mb-6">*/}
                {/*        <div className="bg-white rounded-3xl p-5 shadow-sm border border-gray-100">*/}
                {/*            <div className="flex items-center mb-4">*/}
                {/*                <div*/}
                {/*                    className="w-10 h-10 bg-orange-50 rounded-xl flex items-center justify-center ml-3">*/}
                {/*                    <FaTicket className="text-orange-600"/>*/}
                {/*                </div>*/}
                {/*                <h3 className="font-semibold text-gray-900 text-base">*/}
                {/*                    Charge Code*/}
                {/*                </h3>*/}
                {/*            </div>*/}

                {/*            <input*/}
                {/*                onChange={(e) => {*/}
                {/*                    e.stopPropagation();*/}
                {/*                    handleCreditCodeChange(e.target.value);*/}
                {/*                }}*/}
                {/*                type="text"*/}
                {/*                placeholder="Enter charge code"*/}
                {/*                className="w-full p-4 bg-gray-50 rounded-2xl border-2 border-gray-200 text-gray-900 focus:outline-none focus:border-blue-600 transition-colors text-right"*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*    </section>*/}
                {/*) : (*/}
                    <>
                        <section className="px-4 mb-6">
                            <div className="bg-white rounded-3xl p-5 shadow-sm border border-gray-100">
                                <div className="flex items-center mb-4 gap-4">
                                    <div
                                        className="w-10 h-10 bg-green-50 rounded-xl flex items-center justify-center">
                                        <FaDollarSign className="text-green-600"/>
                                    </div>
                                    <h3 className="font-semibold text-gray-900 text-base">
                                        Charge Amount
                                    </h3>
                                </div>

                                <div className="mb-4 relative">
                                    <input
                                        disabled={selectedGateway === ""}
                                        type="text"
                                        placeholder="Enter amount"
                                        value={Number(selectedAmount).toLocaleString("en-US")}
                                        onChange={(e) => {
                                            handleAmountChange(e);
                                        }}
                                        className="w-full p-4 bg-gray-50 rounded-2xl border-2 border-gray-200 text-gray-900 text-lg font-semibold focus:outline-none focus:border-blue-600 transition-colors text-center"
                                    />
                                    <span
                                        className="div w-auto text-center absolute end-5 text-gray-500 text-[20px] top-[25%]">
                    $
                  </span>
                                </div>

                                <div className="grid grid-cols-3 gap-3">
                                    {AMOUNT_PRESETS.map((amount) => (
                                        <button
                                            disabled={
                                                selectedGateway === "" || "code" === selectedGateway
                                            }
                                            key={amount}
                                            onClick={() => handlePresetAmount(amount)}
                                            className={`p-4 rounded-2xl font-semibold transition-colors ${
                                                selectedAmount === amount
                                                    ? "bg-blue-600 text-white"
                                                    : "bg-blue-50 text-blue-600 hover:bg-blue-100"
                                            }`}
                                        >
                                            {amount.toLocaleString("en-US")}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </section>

                        <section className="px-4 mb-6">
                            <div
                                className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-3xl p-5 border border-indigo-200">
                                <h3 className="font-semibold text-gray-900 mb-4">
                                    Transaction Summary
                                </h3>
                                <div className="space-y-3">
                                    <div className="flex justify-between items-center">
                                        <span className="text-gray-600">Amount</span>
                                        <span className="font-semibold text-gray-900">
                      {selectedAmount.toLocaleString("en-US")} $
                    </span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-gray-600">Fee</span>
                                        <span className="font-semibold text-gray-900">
                      {fee.toLocaleString("en-US")} USDT
                    </span>
                                    </div>
                                    <div className="h-px bg-gray-300"></div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-gray-900 font-semibold">Total</span>
                                        <span className="font-bold text-blue-600 text-xl">
                      {total.toLocaleString("en-US")} USDT
                    </span>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                {/*)}*/}

                <section className="px-4">
                    <button
                        onClick={
                            selectedGateway === "code" ? handleCodeSubmit : handleChargeClick
                        }
                        disabled={
                            (selectedGateway === "code" && chargeCode.trim() === "") ||
                            (selectedGateway !== "code" &&
                                (selectedGateway === "" || selectedAmount <= 0))
                        }
                        className="w-full bg-gradient-to-r from-blue-600 to-indigo-500 text-white py-5 rounded-2xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3"
                    >
                        <FaPlusCircle className="text-xl"/>
                        <span>Charge Wallet</span>
                    </button>
                </section>
            </div>
        </div>
    );
}